// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2PJwj","col":"styles_col__3L9Rw","fulfillmentStatus":"styles_fulfillmentStatus__16oQh","emailCol":"styles_emailCol__1pHgQ"};